import { jsx as s } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import { S as i } from "../../index-nyDQUcyF.js";
import { c as u } from "../../index-DdNCJmwh.js";
import { c as b } from "../../cn-gv_k3DnN.js";
const d = u(
  "group relative w-full overflow-hidden rounded-xl p-sp-6 ",
  {
    variants: {
      indicatorColor: {
        buttercream: "before:bg-spectrum-buttercream",
        blush: "before:bg-spectrum-blush",
        mint: "before:bg-spectrum-mint",
        frost: "before:bg-spectrum-frost",
        lavender: "before:bg-spectrum-lavender-mist",
        sky: "before:bg-spectrum-sky",
        peach: "before:bg-spectrum-peach-sorbet"
      },
      bgColor: {
        surface: "bg-surface",
        marketing1: "bg-marketing-1",
        marketing2: "bg-marketing-2",
        neutral: "bg-neutral",
        techy: "bg-techy",
        info: "bg-info",
        transparent: "bg-transparent"
      },
      withBorder: {
        true: "border border-primary"
      }
    }
  }
), g = m(
  ({
    asChild: t,
    bgColor: o = "surface",
    children: r,
    indicatorColor: e,
    className: a,
    withBorder: p = !1,
    ...f
  }, c) => {
    const n = t ? i : "div", l = e !== void 0;
    return /* @__PURE__ */ s(
      n,
      {
        ref: c,
        className: b(
          d({
            bgColor: o,
            indicatorColor: e,
            withBorder: p,
            className: a
          }),
          {
            "pl-sp-7 before:absolute before:top-1/2 before:-translate-y-1/2 before:left-sp-3 before:h-[calc(100%-var(--fui-sp-6)*2)] before:w-[6px] before:rounded-full": l
          }
        ),
        ...f,
        children: r
      }
    );
  }
);
g.displayName = "Card";
const v = m(
  ({ className: t, children: o, position: r = "top", ...e }, a) => /* @__PURE__ */ s(
    "div",
    {
      ref: a,
      className: b(
        // Compensate for the padding of the card
        // Top
        { "-mx-sp-6 -mt-sp-6": r === "top" },
        // Left
        { "-ml-sp-6 -my-sp-6": r === "left" },
        // Right
        { "-mr-sp-6 -my-sp-6": r === "right" },
        t
      ),
      ...e,
      children: o
    }
  )
);
v.displayName = "CardPreview";
export {
  g as Card,
  v as CardPreview
};
